import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Breadcrumb, Form, Input, Button, message } from 'antd';
import whttp from '../../libs/whttp';
import { API_HOST } from 'configs/env';
import _ from 'lodash';

const Static = () => {
  const onFinish = (values) => {
    whttp.get(
      API_HOST + `/api/mgt/v1/system`,
      { path: values.path },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res;
        if (state === false) {
          return message.error('發生錯誤');
        }
        if (code !== 200) {
          return message.error(reason);
        }

        message.success('新增成功');
      }
    );
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  return (
    <Layout>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to={`/static`}>靜態頁面轉換</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <h2>
        靜態頁面轉換
        <span />
      </h2>
      <Form
        style={{ display: 'flex' }}
        name='basic'
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
      >
        <Form.Item
          style={{ marginRight: '20px' }}
          label='網址'
          name='path'
          rules={[
            {
              required: true,
              message: '請輸入網址',
            },
          ]}
        >
          <Input style={{ width: 400 }} />
        </Form.Item>
        <Form.Item>
          <Button type='primary' htmlType='submit'>
            儲存
          </Button>
        </Form.Item>
      </Form>
      <p>範例：網頁名稱/</p>
      <p style={{ color: 'red' }}>
        ＊＊＊＊如有已存在網頁會直接覆蓋，若網頁不存在會直接轉成首頁
      </p>
    </Layout>
  );
};
export default Static;



// WEBPACK FOOTER //
// ./src/views/Static/StaticInfo.js